export const changeSougaku = sougaku => ({
    type: 'CHANGE_SOUGAKU',
    sougaku: sougaku,
});

export const changeHaiguusha = haiguusha => ({
    type: 'CHANGE_HAIGUUSHA',
    haiguusha: haiguusha,
});

export const changeChild = child => ({
    type: 'CHANGE_CHILD',
    child: child,
});

export const changeKazeiIsangaku1 = KazeiIsangaku1 => ({
    type: 'CHANGE_KAZEIISANGAKU1',
    KazeiIsangaku1: KazeiIsangaku1
});

export const changeKazeiIsangaku2 = KazeiIsangaku2 => ({
    type: 'CHANGE_KAZEIISANGAKU2',
    KazeiIsangaku2: KazeiIsangaku2
});

export const changeKazeiIsangaku3 = KazeiIsangaku3 => ({
    type: 'CHANGE_KAZEIISANGAKU3',
    KazeiIsangaku3: KazeiIsangaku3
});

export const changeIsPaid = isPaid => ({
    type: 'CHANGE_IS_PAID',
    isPaid: isPaid
});

export const setNeedEmailVerify = needEmailVerify => ({
    type: 'SET_NEED_EMAIL_VERIFY',
    needEmailVerify: needEmailVerify
});

export const setZlaboPremium = zlaboPremium => ({
    type: 'SET_ZLABO_PREMIUM',
    zlaboPremium: zlaboPremium
});